import { render, staticRenderFns } from "./VincularNotaFiscalEmitidaModal.vue?vue&type=template&id=0ace354d&scoped=true"
import script from "./VincularNotaFiscalEmitidaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VincularNotaFiscalEmitidaModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VincularNotaFiscalEmitidaModal.vue?vue&type=style&index=0&id=0ace354d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ace354d",
  null
  
)

export default component.exports